import { render, staticRenderFns } from "./index.vue?vue&type=template&id=120dbf12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=120dbf12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120dbf12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\works\\xiangyun\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120dbf12')) {
      api.createRecord('120dbf12', component.options)
    } else {
      api.reload('120dbf12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=120dbf12&scoped=true", function () {
      api.rerender('120dbf12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/relevanceCompany/index.vue"
export default component.exports